import {tr} from '../i18n/idioma';
import {extensionDe, IMAGENES, TABLAS} from '../utilidades/vista-previa';

// Un archivo dentro de la app, sin descargarlo (decision 0092): imagen, PDF
// (tambien Word y PowerPoint que Dropbox convierte) o la tabla de un Excel,
// aislada (sin scripts).
export function VistaPrevia({
  src,
  nombre,
  titulo,
  abrir,
  onCerrar,
}: {
  src: string;
  nombre: string;
  titulo?: string;
  abrir?: {href: string; texto: string};
  onCerrar: () => void;
}) {
  const extension = extensionDe(nombre);
  return (
    <div className="mt-4 rounded-md border border-linea" data-prueba="vista-previa">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-linea px-3 py-2">
        <span className="min-w-0 break-all font-medium">{titulo ?? nombre}</span>
        <span className="flex items-center gap-3">
          {abrir && (
            <a href={abrir.href} target="_blank" rel="noreferrer" className="text-xs text-verde hover:underline">
              {abrir.texto}
            </a>
          )}
          <button
            type="button"
            onClick={onCerrar}
            aria-label={tr('Cerrar la vista previa', 'Close the preview')}
            className="text-apagado hover:text-tinta"
          >
            ×
          </button>
        </span>
      </div>
      {IMAGENES.includes(extension) ? (
        <img src={src} alt={nombre} className="mx-auto max-h-[70vh] max-w-full" />
      ) : (
        <iframe
          key={src}
          src={src}
          title={nombre}
          sandbox={TABLAS.includes(extension) ? '' : undefined}
          className="h-[70vh] w-full bg-white"
        />
      )}
    </div>
  );
}
